import styles from './TabItem.scss';

import { ReferencedEntry } from 'contentful';
import React from 'react';

import { ContentType, MediaAssembly, TabItem as ITabItem, as } from 'src/api/contentful/contentTypes.cloverdotcom';
import { getContentType } from 'src/utils/CloverdotcomEntryUtil';
import { getField, isEntry } from 'src/utils/EntryUtil';

import { AccordionModule } from '../AccordionModule/AccordionModule';
import { CardModuleContainer as CardModule } from '../CardModule/CardModule';
import { TextMediaModulePresentational } from '../TextMediaModule/TextMediaModule';

interface TabItemProps {
  item: ReferencedEntry<ITabItem>;
}

const TabItem: React.FC<TabItemProps> = ({ item }) => {
  if (!isEntry(item)) return null;

  const { module: moduleEntry } = item.fields;

  if (!isEntry(moduleEntry)) return null;

  const contentType = getContentType(moduleEntry);

  switch (contentType) {
    case ContentType.MEDIA_MODULE:
      const mediaEntry = as<MediaAssembly>(ContentType.MEDIA_MODULE, moduleEntry);
      return (
        <TextMediaModulePresentational
          topic={getField(mediaEntry, 'topic')}
          className={styles.textMediaModuleWrapperCustom}
          textBlockClassName={styles.textBoxCustom}
          mediaClassName={styles.mediaCustom}
          textAlignment={getField(mediaEntry, 'textAlignment')}
          titleClassName={styles.titleCustom}
          titleTagName="h3"
          blurbClassName={styles.blurbCustom}
          disableAnimation
        />
      );
    case ContentType.CARD_ASSEMBLY:
      return (
        <CardModule
          hideMainTitle
          entry={item.fields.module}
          className={styles.cardModuleWrapperCustom}
          disableAnimation
        />
      );
    case ContentType.ACCORDION_ASSEMBLY:
      return (
          <AccordionModule
            entry={moduleEntry}
            className={styles.accordionModuleWrapperCustom}
            isTabItem
          />
      );
    default:
      console.warn(`Unrecognized content type ${contentType}`);

      return null;
  }
};

export {
  TabItemProps,
  TabItem,
};
